import {
  Component,
  ElementRef,
  inject,
  Input,
  Renderer2,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';

import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import type { WrappedValue } from '../../mailgun/wrap-value';
import { EmailMailgunHtmlComponent } from '../email-html/email-mailgun-html.component';

@Component({
  selector: 'email-infobox',
  styleUrls: ['./email-infobox.component.less'],
  template: `<div [class]="getClassNames()">
    <table class="infobox-table" cellspacing="0" cellpadding="0">
      <tr>
        <td class="infobox-content web-infobox-markup">
          <mailgun-html #htmlContents [html]="contents" />
        </td>
      </tr>
    </table>
  </div>`,
  hostDirectives: [SsrMarkToUnwrapDirective],
  // eslint-disable-next-line @angular-eslint/use-component-view-encapsulation
  encapsulation: ViewEncapsulation.None,
  imports: [EmailMailgunHtmlComponent],
})
export class EmailInfoboxComponent {
  @Input() public contents: WrappedValue<string>;
  @Input() public wrapperTag?: keyof HTMLElementTagNameMap;

  @Input() public theme: 'info' | 'warning' | 'success' | 'critical' = 'warning';

  @ViewChild('htmlContents', { static: true, read: ElementRef })
  public htmlContents: ElementRef;

  private renderer = inject(Renderer2);

  public ngOnInit() {
    if (this.wrapperTag) {
      const wrapper: HTMLElement = this.renderer.createElement(this.wrapperTag);
      const el: HTMLElement = this.htmlContents.nativeElement;

      el.parentElement?.appendChild(wrapper);
      wrapper.appendChild(el);
    }
  }
  public getClassNames() {
    return ['infobox', `infobox-${this.theme}`];
  }
}
